import React from 'react';
import style from './CtaSection.module.less';
import { Section } from '../Section';
import { SteamCard } from '../SteamCard';
import { NewsletterCard } from '../NewsletterCard';
import { DiscordCard } from '../DiscordCard';

export const CtaSection: React.FC = () => {
  return (
    <>
      <Section className={style.ctaSection}>
        <h1 id="cta">Support us!</h1>
        <div className={style.row}>
          <div className={style.content}>
            <SteamCard />
            <NewsletterCard tags={['parallel-experiment']} />
            <DiscordCard />
          </div>
        </div>
        <div className={style.gameMedia}>
          <h3>Game Journalists & Streamers</h3>
          <p>Covering our game? We’ve prepared a comprehensive Press Kit to make your job easier. If you have any questions or would like to discuss collaboration opportunities, feel free to reach out at <strong><a href="mailto:contact@elevenpuzzles.com">contact@elevenpuzzles.com</a></strong></p>
          <p>Thank you for your support!</p>
          <a href="https://drive.google.com/drive/folders/1zDKC8rjhyMAWMB9l39o6OsmRBHZ8yaCJ?usp=sharing" target="_blank">
            <button type="submit" className={style.pressKit}>
              Press Kit
            </button>
          </a>
        </div>
      </Section>
    </>
  );
};
